import { createRoute } from "@tanstack/solid-router";
import { msg } from "@lingui/core/macro";
import { Bot } from "lucide-solid";
import { AI_CHATBOT_KEY } from "@space/shared";
import { adminRoute } from "./admin";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
// FLAGS: la página entera se gatea por la capacidad de chatbot.
import { FeatureGate } from "@/features/flags/feature-gate";
import { AcademyBotPanel } from "@/features/academy-bot/deflection-panel";

function AdminAcademyBotPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="4xl">
      <FeatureGate feature={AI_CHATBOT_KEY}>
        <PageHeader
          title={t(msg`Academy assistant`)}
          description={t(
            msg`What the assistant tells people who are not students yet, and how often it saves your team a conversation.`,
          )}
          icon={Bot}
        />
        <div class="mt-6">
          <AcademyBotPanel />
        </div>
      </FeatureGate>
    </PageContainer>
  );
}

export const adminAcademyBotRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/academy-bot",
  component: AdminAcademyBotPage,
});
